import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin/admin.service';
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {
  loginAdminDetails: any;
  adminPanel = true;
  selectedSection = 1;
  constructor(private router:Router,private _adminService:AdminService ) { }

  ngOnInit(): void {
    this.loginAdminDetails = JSON.parse(
      localStorage.getItem('loginAdminDetails')
    );
    const currentUrl = this.router.url;
    if(currentUrl.includes('social-hub'))
      this.selectedSection = 2;
    else if(currentUrl.includes('banners'))
      this.selectedSection = 3;
    else if(currentUrl.includes('banner-hub'))
      this.selectedSection = 4
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('/signin2');
  }

  changeType(index){
     this.selectedSection = index;
     this.adminPanel = !this.adminPanel;

     if(this.selectedSection == 1){
      this.router.navigateByUrl('/admin')
     }
     else if(this.selectedSection == 2) {
      this.router.navigateByUrl('/admin/social-hub/post-hub');
     }
     else if(this.selectedSection == 3){
      this.router.navigateByUrl('/admin/banners/list-banner')
     }
     else if(this.selectedSection == 4){
      this.router.navigateByUrl('/admin/banner-hub/banner-list')
     }
  }

}
